import { render, staticRenderFns } from "./DT_ChangePassword.vue?vue&type=template&id=af826f70&scoped=true&"
import script from "./DT_ChangePassword.vue?vue&type=script&lang=js&"
export * from "./DT_ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./Data_Tools.css?vue&type=style&index=0&id=af826f70&prod&scoped=true&lang=css&"
import style1 from "./DT_ChangePassword.vue?vue&type=style&index=1&id=af826f70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af826f70",
  null
  
)

export default component.exports